import type { DetailedSummaryDepreciationItemProps } from '@pages/Depreciation/context/types'
import type { EditDetailedSummaryDepreciationFormProps } from '../form/types'

export const setInitialValues = (data: DetailedSummaryDepreciationItemProps) => {
  const parsedData: EditDetailedSummaryDepreciationFormProps = {
    accountCode: data.accountingCode || '',
    accountDescription: data.accountingCode || '',
    accountDescriptionText: data.accountingDescription || '',
    depreciationValue: data.depreciationAmount?.toFixed(2) || '',
    observations: data.observations || '',
    filiCode: '',
    competenceDate: ''
  }

  return parsedData
}
